<template>
  <QSpinner v-if="loading" />
  <SelectList
    v-else
    v-model="selectedValue"
    v-bind="$attrs"
    :clearable="clearable"
    :multiple="multiple"
    option-label="name"
    :options="briefSets"
    :use-chips="useChips"
  />
</template>

<script>
import BriefSet from "shared/resources/BriefSet";

import SelectList from "src/components/common/SelectList.vue";

export default {
  name: "BriefSetSelector",
  components: {
    SelectList,
  },
  props: {
    modelValue: {
      type: [String, Number, Object, Array],
      default: null,
    },
    organisationId: {
      type: [String, Number],
      required: true,
    },
    userIds: {
      type: Array,
      default: null,
    },
    multiple: {
      type: Boolean,
    },
    useChips: {
      type: Boolean,
    },
    clearable: {
      type: Boolean,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      briefSets: [],
      loading: false,
    };
  },
  computed: {
    selectedValue: {
      get() {
        if (!this.modelValue) {
          return this.modelValue;
        }

        if (Array.isArray(this.modelValue)) {
          return this.modelValue.map((element) => Number(element));
        }

        return Number(this.modelValue);
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    organisationId: "loadBriefSets",
  },
  mounted() {
    this.loadBriefSets();
  },
  methods: {
    async loadBriefSets() {
      this.loading = true;

      try {
        const filters = { organisationId: { eq: this.organisationId } };

        if (this.userIds?.length) {
          filters.userId = this.userIds;
        }

        const response = await BriefSet.where(filters).per(999).all();

        this.briefSets = response.data.map((briefSet) => ({
          ...briefSet,
          id: Number(briefSet.id),
        }));
      } catch {
        this.$q.notify("There was an issue loading brief sets");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
